import { render } from "./mvt-header-contact.vue?vue&type=template&id=7633eb3f"
import script from "./mvt-header-contact.vue?vue&type=script&lang=js"
export * from "./mvt-header-contact.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__